<template>
  <div class="prepare-question__head">
    <div class="form-group">
      <div class="row">
        <div class="col-lg-8 col-xl-9">
          <div class="display-flex form-group__cat-title">
            <div class="form-item full-width">
              <label class="display-block secondary-color-txt font-sanpro-semibold">Thể loại</label>
              <div class="item item__class input-custom-icon select-custom">
                <select class="primary-color-txt border-rd-20 font-size-15 form-h35 color_bg_gray_light border-0 full-width" v-model="questionDetail.type">
                  <option v-for="(item, index) of question_format" :key="index" :value="item.value">{{ item.name }}</option>
                </select>
                <i class="icon-arrow-down font-size-13 primary-color"></i>
              </div>
            </div>
            <div class="form-item full-width">
              <label class="display-block secondary-color-txt font-sanpro-semibold">Tiêu đề <span class="color-err">*</span></label>
              <input
                type="text"
                name="title"
                v-model="questionDetail.title"
                class="form-h35 color_bg_gray_light border-0 full-width border-rd-20"
                autocomplete="off"
                :class="{'form-item-err': isSubmit && !questionDetail.title}"
              >
              <div v-if="isSubmit && !questionDetail.title" class="form-item__noti color-err font-size-15 mt-2">Bạn hãy nhập vào tiêu đề</div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-xl-3">
          <div class="form-item text-right">
            <a href="javascript:;" class="font-size-17 primary-color" @click="viewQuestionSaved">Câu hỏi có sẵn</a>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group">
      <!-- <div class="row">
        <div class="col-md-6">
          <div class="form-item">
            <label class="display-block secondary-color-txt font-sanpro-semibold">Tiêu đề <span class="color-err">*</span></label>
            <input
              type="text"
              name="title"
              v-model="questionDetail.title"
              class="form-h35 color_bg_gray_light border-0 full-width border-rd-20"
              autocomplete="off"
              :class="{'form-item-err': isSubmit && !questionDetail.title}"
            >
            <div v-if="isSubmit && !questionDetail.title" class="form-item__noti color-err font-size-15 mt-2">Bạn hãy nhập vào tiêu đề</div>
          </div>
        </div>
        <div class="col-md-6"> -->
          <div class="form-file-hide position-rel img-layout">
            <template v-if="questionDetail.imageUrl">
              <button
                class="btn btn-danger del-img del-img-question position-rel float-right ml-4"
                v-b-tooltip.hover title="Xóa ảnh"
                variant="outline-danger"
                @click="delImgOfQuestion"
              >
                <i class="icon-lesson-trash color-light font-size-18"></i>
              </button>
              <img 
                class="img-question"
                :src="questionDetail.isSample ? `${cdnUrl}/${questionDetail.imageUrl}`:`${appUrl}/${questionDetail.imageUrl}`" 
                alt="Ảnh câu hỏi" 
              />
              <!-- :src="questionDetail.isSample ? `${uploadUrl}/${questionDetail.imageUrl}`:`${appUrl}/${questionDetail.imageUrl}`"  -->
            </template>
            <a v-else href="javascript:;" class="full-box display-flex-center justify-content-center flex-direction-col font-size-16 border-rd-20">
              <i class="icon-upload d-block"></i> 
              <span class="d-block secondary-color-txt">Tải ảnh câu hỏi</span>
            </a>
            <input type="file" class="ipt-upload cursor-pointer" @change="changeImgQuestion($event)" accept="image/*">
          </div>
        <!-- </div>
      </div> -->
    </div>
    <div class="form-group">
      <label class="display-block secondary-color-txt font-sanpro-semibold">Câu hỏi <span class="color-err"></span></label>
      <div
        class="form-item__editor"
        :class="{ 'form-item-err': isSubmit && (!questionDetail.content || (questionDetail.content && questionDetail.content === contentDefault)) }"
      >
        <EditorCK v-if="indexQuestionWorking > -1" :contentEditor="questionDetail.content" :position="indexQuestionWorking" />
      </div>
      <div v-if="isSubmit && (!questionDetail.content || (questionDetail.content && questionDetail.content === contentDefault))" class="form-item__noti color-err font-size-15 mt-2">
        Bạn hãy nhập vào nội dung câu hỏi
      </div>
    </div>
    <ModalQuestionSample />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { STORE_KEY, CONTENT_EDITOR_DEFAULT } from './../../_store/constants'
import EditorCK from '@/modules/question/EditorCK.vue'
import { APP_CONFIG } from "@/utils/constants"
import mixinsQuestions from './../../_store/mixinsQuestions'
import { uploadImg } from '@/store/common/api'
import ModalQuestionSample from './ModalQuestionSample.vue'

export default {
  name: 'QuestionHead',
  mixins: [ mixinsQuestions ],
  props: {
    isSubmit: Boolean
  },
  components: {
    EditorCK,
    ModalQuestionSample
  },
  data () {
    return {
      imgQuestion: '',
      uploadUrl: APP_CONFIG.uploadUrl,
      cdnUrl: APP_CONFIG.cdnUrl,
      available: false,
      appUrl: APP_CONFIG.appUrl,
      contentDefault: CONTENT_EDITOR_DEFAULT
    }
  },
  computed: {
    ...mapState(STORE_KEY, ['examInfo', 'question_format', 'questionDetail', 'indexQuestionWorking', 'examInfo', 'idModalQuestionSample', 'paramsGetQuestionsSample'])
  },
  methods: {
    ...mapActions('common', ['setLoading']),
    ...mapActions(STORE_KEY, ['acSetQuestionDetail', 'acSetParamsGetQuestionsData']),

    viewQuestionSaved () {
      this.acSetParamsGetQuestionsData({
        ...this.paramsGetQuestionsSample,
        classId: this.examInfo.classId,
        subjectId: this.examInfo.subjectId || 0
      })
      this.$bvModal.show(this.idModalQuestionSample)
      // apiGetListChooseQuestion({classId:1 ,subjectId:1}).then(res =>{
      //   this.listPracticeBook = res.data.listPracticeBook
      //   this.listPracticeTKTDG = res.data.listPracticeTKTDG
      //   this.listPracticeChuyende = res.data.listPracticeChuyende
      // })
      // obj.Editing = false;
      // this.$bvModal.show("modal-xl");
    },

    changeImgQuestion (evt) {
      if (evt.target.files.length > 0) {
        let self = this;
        this.setLoading(true);
        uploadImg(evt).then(res => {
          self.questionDetail.imageUrl = res;
          self.acSetQuestionDetail({ ...self.questionDetail })
        }).finally(() => this.setLoading(false));
      }
    },

    delImgOfQuestion () {
      this.questionDetail.imageUrl = ''
      this.acSetQuestionDetail({...this.questionDetail})
    }
  }
}
</script>

<style lang="scss" scoped>
.form-group {
  &__cat-title {
    .form-item {
      &:not(:last-child) {
        margin-right: 15px;
      }
    }

    @media screen and ( max-width: 767px ) {
      display: block;

      .form-item {
        margin-bottom: 10px;

        &:not(:last-child) {
          margin-right: 0;
        }
      }
    }
  }
}
</style>